import { render, staticRenderFns } from "./OrdersFormPayment.vue?vue&type=template&id=726b2e79&"
import script from "./OrdersFormPayment.vue?vue&type=script&lang=js&"
export * from "./OrdersFormPayment.vue?vue&type=script&lang=js&"
import style0 from "./OrdersFormPayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports